const list = {
  path: 'list',
  component: resolve => require(['../../../../../../../../pages/admin/merchant/signing/yftAlipay/accessPay/list'], resolve)
}

export default list
